import React from 'react'
import {VisaLogo} from './VisaLogo'
import amexLogo from './amex_logo.png'
import mastercardLogo from './mastercard_logo.png'
import discoverLogo from './discover_logo.png'

const CARD_LOGOS = {
  Visa: ({scale}) => (
    <VisaLogo
      width={Math.round(50 * scale)}
      style={{filter: 'brightness(0) invert(1)'}}
    />
  ),
  'American Express': ({scale}) => (
    <img
      src={amexLogo}
      alt="American Express"
      style={{width: Math.round(65 * scale), filter: 'brightness(0) invert(1)'}}
    />
  ),
  MasterCard: ({scale}) => (
    <img
      src={mastercardLogo}
      alt="Mastercard"
      style={{width: Math.round(50 * scale)}}
    />
  ),
  Discover: ({scale}) => (
    <img
      src={discoverLogo}
      alt="Discover"
      style={{width: Math.round(60 * scale), filter: 'brightness(0) invert(1)'}}
    />
  ),
}

export function SavedBlankCard({
  width = 350,
  cardBrand = '',
  lastFour = '',
  cardholderName = '',
  expiryDate = '',
}) {
  const height = Math.round(width * (184 / 350))
  const scale = width / 350

  const text = {
    color: '#fff',
    fontFamily: 'sans-serif',
    lineHeight: 1,
    userSelect: 'none',
  }

  const label = {
    ...text,
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: Math.round(10 * scale),
    lineHeight: 1,
    letterSpacing: 0,
    textTransform: 'uppercase',
    marginBottom: Math.round(4 * scale),
  }

  const value = {
    ...text,
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 700,
    fontStyle: 'normal',
    fontSize: Math.round(12 * scale),
    lineHeight: 1,
    letterSpacing: 0,
  }

  const cardNumber = {
    ...text,
    fontFamily: 'Open Sans, sans-serif',
    fontWeight: 700,
    fontStyle: 'normal',
    fontSize: Math.round(18 * scale),
    lineHeight: 1,
    letterSpacing: 0,
    whiteSpace: 'pre-wrap',
  }

  return (
    <div
      style={{position: 'relative', width, height, flexShrink: 0, zIndex: 1}}
    >
      {/* Card background */}
      <svg
        preserveAspectRatio="xMinYMid meet"
        viewBox="0 0 350 184"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{width, height, display: 'block'}}
      >
        <path
          d="M94.6477 171.572C61.2723 171.572 29.3239 167.161 0 159.176V173.187C0 179.159 5.81205 184 12.9819 184H337.018C344.188 184 350 179.159 350 173.187V23C328.239 107.477 222.17 171.572 94.6477 171.572Z"
          fill="#252B44"
        />
        <path
          d="M264.466 0C244.386 78.9321 157.894 138.287 54.2588 138.287C35.4995 138.287 17.3275 136.359 0 132.681V159.561C29.3242 167.573 61.2723 172 94.6477 172C222.17 172 328.238 107.683 350 22.9145V10.8502C350 4.85769 344.188 0 337.018 0H264.466Z"
          fill="#2C3556"
        />
        <path
          d="M265 0H110.82C105.473 38.9469 62.8502 69.2863 11.1042 69.2863C7.36535 69.2863 3.62646 69.1337 0 68.7978V134.324C17.3625 138.048 35.5712 140 54.3683 140C158.213 140 244.879 79.9098 265 0Z"
          fill="#353F63"
        />
        <path
          d="M111 0H13.0293C5.83359 0 0 5.0395 0 11.2563V70.4995C3.63236 70.8437 7.37735 71 11.1223 71C62.9525 71 105.645 39.9102 111 0Z"
          fill="#495580"
        />
        <path
          d="M324.447 45.8558H300.933C299.313 45.8558 298 44.5391 298 42.9148V25.9409C298 24.3166 299.313 23 300.933 23H324.447C326.067 23 327.38 24.3166 327.38 25.9409V42.9148C327.38 44.5391 326.067 45.8558 324.447 45.8558Z"
          fill="url(#paint0_linear_2364_8710)"
        />
        <mask
          id="mask0_2364_8710"
          style={{maskType: 'luminance'}}
          maskUnits="userSpaceOnUse"
          x="298"
          y="23"
          width="30"
          height="23"
        >
          <path
            d="M324.376 45.856H301.004C299.345 45.856 298 44.5078 298 42.8443V26.0118C298 24.3485 299.345 23 301.004 23H324.376C326.035 23 327.38 24.3483 327.38 26.0118V42.8443C327.38 44.5078 326.035 45.856 324.376 45.856Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_2364_8710)">
          <g opacity="0.5">
            <path
              d="M329.266 30.9603V30.4639H316.99L319.762 27.6909H328.309V27.1945H319.557L316.29 30.4637H312.937V22.0459H312.442V30.4639H309.089L305.829 27.1948H297.07V27.6912H305.624L308.39 30.4642H296.113V30.9606H308.746V37.8962H296.113V38.3926H308.39L305.624 41.1656H297.07V41.6555H305.829L309.089 38.3926H312.442V46.8106H312.937V38.3926H316.29L319.557 41.6555H328.309V41.1656H319.762L316.99 38.3926H329.266V37.8962H316.64V30.9606H329.266V30.9603ZM316.145 37.896H309.241V30.9603H316.145V37.896Z"
              fill="url(#paint1_linear_2364_8710)"
            />
          </g>
        </g>
        <mask
          id="mask1_2364_8710"
          style={{maskType: 'luminance'}}
          maskUnits="userSpaceOnUse"
          x="298"
          y="23"
          width="30"
          height="23"
        >
          <path
            d="M324.376 45.856H301.004C299.345 45.856 298 44.5078 298 42.8443V26.0118C298 24.3485 299.345 23 301.004 23H324.376C326.035 23 327.38 24.3483 327.38 26.0118V42.8443C327.38 44.5078 326.035 45.856 324.376 45.856Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_2364_8710)">
          <path
            d="M329.519 31.1742V30.6778H317.243L320.015 27.905H328.562V27.4087H319.81L316.543 30.6778H313.19V22.2598H312.695V30.6778H309.342L306.082 27.4087H297.323V27.905H305.877L308.643 30.6778H296.366V31.1742H308.999V38.1098H296.366V38.6062H308.643L305.877 41.3792H297.323V41.8688H306.082L309.342 38.6062H312.695V47.0242H313.19V38.6062H316.543L319.81 41.8688H328.562V41.3792H320.015L317.243 38.6062H329.519V38.1098H316.893V31.1742H329.519ZM316.398 38.1098H309.494V31.1742H316.398V38.1098Z"
            fill="#231912"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_2364_8710"
            x1="298.9"
            y1="23.0981"
            x2="327.997"
            y2="46.8756"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B56110" />
            <stop offset="0.1507" stopColor="#B56110" />
            <stop offset="0.4498" stopColor="#E5AD5C" />
            <stop offset="0.5922" stopColor="#F9CC7B" />
            <stop offset="0.6932" stopColor="#FFE6A6" />
            <stop offset="0.7909" stopColor="#F9CC7B" />
            <stop offset="1" stopColor="#B56110" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2364_8710"
            x1="296.113"
            y1="34.4281"
            x2="329.266"
            y2="34.4281"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B56110" />
            <stop offset="0.1507" stopColor="#B56110" />
            <stop offset="0.4638" stopColor="#E5AD5C" />
            <stop offset="0.6129" stopColor="#F9CC7B" />
            <stop offset="0.7204" stopColor="#FFE6A6" />
            <stop offset="0.8387" stopColor="#F9CC7B" />
            <stop offset="1" stopColor="#B56110" />
          </linearGradient>
        </defs>
      </svg>

      {/* Overlaid card content */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          padding: `${Math.round(20 * scale)}px ${Math.round(24 * scale)}px`,
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        {/* Top: logo */}
        <div>
          {CARD_LOGOS[cardBrand] &&
            React.createElement(CARD_LOGOS[cardBrand], {scale})}
        </div>

        {/* Card number */}
        <div>
          <div style={label}>Card Number</div>
          <div style={cardNumber}>
            {'****  ****  ****  '}
            {lastFour}
          </div>
        </div>

        {/* Bottom: cardholder + expiry */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
          }}
        >
          <div>
            <div style={label}>Card Holder Name</div>
            <div style={value}>{cardholderName}</div>
          </div>
          <div style={{textAlign: 'left'}}>
            <div style={label}>Expiry Date</div>
            <div style={value}>{expiryDate}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
